"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return "\n    <rect x=\"4\" y=\"4\" width=\"68\" height=\"24\" rx=\"5\" fill=\"black\" fill-opacity=\"0.2\"/>\n    <rect x=\"8\" y=\"8\" width=\"60\" height=\"16\" rx=\"2\" fill=\"black\" fill-opacity=\"0.8\"/>\n    <path d=\"M9 17H20L22 13L25 20L29 12L31 21L34 10L37 20L40 17H55L58 13L60 20L63 17H67\" stroke=\"#4EFAC9\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n";
};